import type { ContentElementInfoboxProps } from '@vgn-medien-holding/vgn-fe-components';

const classProps = {
  root: 'grid gap-default gap-y-2',
  container: 'mt-4 border-y border-gray-650/25 bg-white p-12 text-gray-700 shadow-card-sm md:px-28 md:py-14',
  text: 'prose prose-sm',
  heading: 'mb-4 text-base font-bold',
} as ContentElementInfoboxProps['classProps'];

export default classProps;
